<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="white"
      centered
      icons-and-text
      fixed-tabs
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#1">
       Citas agendadas
        <v-icon color="success">mdi mdi-clipboard-check</v-icon>
      </v-tab>

      <v-tab href="#2">
        Agendar cita
        <v-icon color="success">mdi mdi-clipboard-arrow-down</v-icon>
      </v-tab>
      <v-btn color="warning" outlined small @click="clearAll" :disabled="!hasPendingSelection">
        <v-icon left>mdi-eraser</v-icon> Limpiar campos
      </v-btn>
    </v-tabs>
    
    <v-tabs-items v-model="tab">
      <v-tab-item value="1">
        <v-card flat>
          <v-card-text> </v-card-text>
          <RegisterTable
            :listSpecialityFromRegister="listSpecialityFromRegister"
          />
        </v-card>
      </v-tab-item>
      <v-tab-item value="2">
        <v-card flat>
          <v-card-text> </v-card-text>
          <FormSpeciality
  ref="formSpec"
  :key="formKey"
  @updateList="updateList"
  :existingStudies="addedStudiesList"
  :registeredSpecialities="listSpecialityFromRegister"
  @update:pending="onPendingSelection"
/>         
  <template v-if="addOnListSpeciality.length > 0">
            <AddonSpecialityTable :addOnListSpeciality="addOnListSpeciality" @update-list="onDeleteFromTable" />
          </template>
          
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import AddonSpecialityTable from "@/components/appointments/speciality/AddonSpecialityTable.vue";
import RegisterTable from "@/components/appointments/speciality/RegisterTable.vue";
import FormSpeciality from "@/components/appointments/speciality/FormSpeciality.vue";
import { SpecialityAddOnRequest } from "@/core/request";
export default {
  components: {
    AddonSpecialityTable,
    RegisterTable,
    FormSpeciality,
  },
  props: {
    patientData: Object,
    registeredSpecialities: {
      type: Array,
      default: () => []
    },
    medicalPractice: {
    type: Object,
    default: () => ({})
  }
  },  
  data() {
    return {
      tab: 1,
      formKey: 0,
      addSpeciality: null,
      speciality: null,
      listSpecialityFromRegister: [],
      addOnListSpeciality: [],
      activeButton: true,
      hasPendingSelection: false,
    };
  },
  created() {
    this.listTableSpecialityFromRegister();
  },
  methods: {
    listTableSpecialityFromRegister() {
      let data = {
        idPatient: this.patientData.idPatient,
        idMedicalPractice: this.patientData.idMedicalPractice,
      };
      SpecialityAddOnRequest.listSpecialityOnRegister(data).then((res) => {
        let { code, status, data } = res.data;
        if (code == 200 && status == "OK") {
          this.listSpecialityFromRegister = data;
        } else {
        }
      });
    },
    // getDataConsulty(idMedPractice) {
    //   let idMedicalPractice = idMedPractice;
    //   let params = { idMedicalPractice: idMedicalPractice };
    //   MedicalPracticeRequest.listMedicalPracticeById(params).then((res) => {

    //   });
    // },
    updateList(list) {
  const newElement = list[list.length - 1];

  const dupLocal = this.addOnListSpeciality.some(it =>
    it.speciality.idSpeciality             === newElement.speciality.idSpeciality &&
    (it.modality?.idModality || null)      === (newElement.modality?.idModality || null) &&
    (it.studyProfile?.idStudyProfile || null) === (newElement.studyProfile?.idStudyProfile || null)
  )
  if (dupLocal) {
    list.splice(list.length - 1, 1)
    this.$utilFront.notifications(
      'Cita ya registrada, no se puede registrar dos veces',
      'ERROR'
    )
    return
  }

  const esStatusBloqueado = (study) => {
  
  const estadosBloqueados = [
    "por comenzar",
    "por cerrar", 
    "por interpretar",
    "por atender",
    "por iniciar"
  ];
  
  const statusLower = study.nameStatus?.toLowerCase() || '';
  
  return estadosBloqueados.includes(statusLower);
};

  if (this.medicalPractice && Array.isArray(this.medicalPractice.studies)) {
    const existeEstudioIgualBloqueado = this.medicalPractice.studies.some((est) => {
      return (
        est.idSpeciality === newElement.speciality.idSpeciality &&
        est.idModality === newElement.modality.idModality &&
        est.idModalityStudy === newElement.studyProfile.idStudyProfile &&
        esStatusBloqueado(est)
      );
    });

    if (existeEstudioIgualBloqueado) {
      list.splice(list.length - 1, 1);
      this.$utilFront.notifications(
        "Cita ya agendada. No se puede agendar dos veces.",
        "ERROR"
      );
      return; 
    }
  }

  let elementsFiltered = [];
  const specialitiesStudies = [this.$cnst.SPECIALITY_IMAGE, this.$cnst.SPECIALITY_LABORATORY];
  const statusCanceledStudy = [4, 11, 12];
  const statusCanceledMedicalPractice = [4, 2];

  if (this.$utilFront.nonEmptyList(this.listSpecialityFromRegister)) {
    elementsFiltered = this.listSpecialityFromRegister.filter((item) => {
      if (
        specialitiesStudies.includes(item.idSpeciality) &&
        specialitiesStudies.includes(newElement.speciality.idSpeciality)
      ) {
        return (
          newElement.studyProfile.idStudyProfile === item.idStudyModality &&
          !statusCanceledStudy.includes(item.studyStatus)
        );
      } else {
        return (
          newElement.speciality.idSpeciality === item.idSpeciality &&
          !statusCanceledMedicalPractice.includes(item.medicalPracticeStatus)
        );
      }
    });
  }

  if (this.$utilFront.nonEmptyList(elementsFiltered)) {
    list.splice(list.length - 1, 1);
    this.$utilFront.notifications(
      "Cita ya registrada, no se puede registrar dos veces",
      "ERROR"
    );
    return;
  }

this.addOnListSpeciality = [...this.addOnListSpeciality, newElement];
this.$emit("addStudies", this.addOnListSpeciality);
},
clearAll() {
  this.formKey++;
  this.hasPendingSelection = false;         
  this.$emit('clear-labs');  
},
onPendingSelection(pending) {
  // pending puede ser el objeto seleccionado o null/empty cuando se borra
  const hasSomething = !!(
    pending &&
    ( (pending.especialityAppointment && pending.especialityAppointment.idSpeciality) ||
      (pending.modalityAppointment) ||
      (pending.studyProfileAppointment && pending.studyProfileAppointment.idStudyModality) )
  );
  this.hasPendingSelection = hasSomething;
  this.$emit('pending-selection', pending);
},
  onDeleteFromTable(newList) {
      this.addOnListSpeciality = newList
      this.$emit("addStudies", newList)

      this.formKey++          
    },
    // pushListToConsultas() {
    //   this.activeButton = true;
    //   if (this.addOnListSpeciality.length > 0) {
    //     this.$emit("addStudies", this.addOnListSpeciality);
    //     this.$utilFront.notifications(
    //       "Citas agregadas correctamente",
    //       "SUCCESS"
    //     );
    //   } else {
    //     this.$utilFront.notifications("Error al agregar citas", "ERROR");
    //   }
    // },
  },
};
</script>
